import React, { useEffect, useRef } from "react";
import QRCode from "qrcode";

export default function SimpleQRCode({ value = "", size = 128 }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    if (canvasRef.current) {
      QRCode.toCanvas(canvasRef.current, value, { width: size });
    }
  }, [value, size]);

  return <canvas ref={canvasRef} width={size} height={size} />;
}
